<template>
  <div>
    <div class="reason" v-if="type == 1 && list.reason">
      未通过原因：{{ list.reason }}
    </div>
    <van-cell-group class="body kuang">
      <van-cell 
        class="custom-cell-title"
        title="（一）基本信息"
      />
      <van-cell 
        v-if="list.schoolTypeTxt" 
        title="学校类型" 
        :value="list.schoolTypeTxt" 
      />
      <van-cell 
        v-if="list.schoolAreaTxt" 
        title="学校所处区域" 
        :value="list.schoolAreaTxt" 
      />
      <van-cell
        class="custom-cell-title"
        title="（二）少先队组织信息"
      />
      <van-cell 
        v-if="list.zhongDuiNum" 
        title="中队数量" 
        :value="list.zhongDuiNum" 
      />
      <van-cell 
        v-if="list.shaoXianDuiPeopleNum" 
        title="少先队员人数" 
        :value="list.shaoXianDuiPeopleNum" 
      />
      <van-cell 
        v-if="list.schoolGradePeopleNum" 
        :title="'本校' + list.schoolGradeName + '学生数'"
        :value="list.schoolGradePeopleNum" 
      />
      <van-cell 
        v-if="list.sdhDateTxt" 
        title="最近一次少代会召开时间" 
        :value="list.sdhDateTxt === '未开过' ? list.sdhDateTxt : format(props.list.sdhDateTxt, 6)"
      />
      <van-cell 
        v-if="list.ruduiPiciTxt" 
        title="学校学生分几批次入队" 
        :value="list.ruduiPiciTxt" 
      />
      <van-cell 
        v-if="list.isHljJzActivityTxt" 
        title="学校开展“红领巾奖章”争章活动情况" 
        :value="list.isHljJzActivityTxt" 
      />
      <van-cell 
        v-if="list.isHljPeiFaTxt" 
        title="学生入队时首次佩戴的红领巾是否由学校配发" 
        :value="list.isHljPeiFaTxt" 
      />
      <van-cell 
        v-if="list.sxdClassDateTxt" 
        title="是否有少先队队室" 
        :value="list.sxdClassDateTxt" 
      />
      <van-cell 
        v-if="list.sxdGhdDateTxt" 
        title="是否有少先队鼓号队" 
        :value="list.sxdGhdDateTxt" 
      />
      <van-cell 
        v-if="list.sxdHdkTxt" 
        title="少先队活动课课时安排情况" 
        :value="list.sxdHdkTxt" 
      />
      <van-cell 
          class="custom-cell-title"
          title="（三）学校少工委主任信息"
        />
      <van-cell 
        v-if="list.sgwZhuRenTxt" 
        title="学校少工委主任由谁来担任" 
        :value="list.sgwZhuRenTxt" 
      />
      <van-cell 
        v-if="list.sgwZhuRenName" 
        title="学校少工委主任姓名" 
        :value="list.sgwZhuRenName" 
      />
      <van-cell 
        v-if="list.zzmmTxt" 
        title="政治面貌" 
        :value="list.zzmmTxt" 
      />
      <van-cell 
        v-if="list.phone" 
        title="手机号" 
        :value="list.phone" 
      />
      <van-cell 
        class="custom-cell-title"
        title="（四）大队辅导员信息"
      />
      <van-cell 
        v-if="list.daDuiFdyTpyeTxt" 
        title="大队辅导员身份类型" 
        :value="list.daDuiFdyTpyeTxt" 
      />
      <van-cell 
        v-if="list.daDuiFdyName" 
        title="姓名" 
        :value="list.daDuiFdyName" 
      />
      <van-cell 
        v-if="list.daDuiFdySexTxt" 
        title="性别" 
        :value="list.daDuiFdySexTxt" 
      />
      <van-cell 
        v-if="list.daDuiFdyBirthday" 
        title="出生年月" 
        :value="format(list.daDuiFdyBirthday, 6)" 
      />
      <van-cell 
        v-if="list.daDuiFdyZzmmTxt" 
        title="政治面貌" 
        :value="list.daDuiFdyZzmmTxt" 
      />
      <van-cell 
        v-if="list.daDuiFdyPhone" 
        title="手机号" 
        :value="list.daDuiFdyPhone" 
      />
      <van-cell 
        v-if="list.isSfsTxt" 
        title="是否师范生" 
        :value="list.isSfsTxt" 
      />
      <van-cell 
        v-if="list.eduTxt" 
        title="全日制教育学历" 
        :value="list.eduTxt" 
      />
      <van-cell 
        v-if="list.majorTxt" 
        title="所学专业大类" 
        :value="list.majorTxt" 
      />
      <van-cell 
        v-if="list.isGatOrAbroadTxt" 
        title="毕业院校是否为港澳台或国外院校" 
        :value="list.isGatOrAbroadTxt" 
      />
      <van-cell 
        v-if="list.collegeTxt" 
        title="毕业院校" 
        :value="list.collegeTxt" 
      />
      <van-cell 
        v-if="list.highestEduTxt" 
        title="最高教育学历" 
        :value="list.highestEduTxt" 
      />
      <van-cell 
        v-if="list.highestMajorTxt" 
        title="所学专业大类" 
        :value="list.highestMajorTxt" 
      />
      <van-cell 
        v-if="list.isHighestGatOrAbroadTxt" 
        title="毕业院校是否为港澳台或国外院校" 
        :value="list.isHighestGatOrAbroadTxt" 
      />
      <van-cell 
        v-if="list.highestCollegeTxt" 
        title="毕业院校" 
        :value="list.highestCollegeTxt" 
      />
      <van-cell 
        v-if="list.highestEduXZTxt" 
        title="最高教育学历性质" 
        :value="list.highestEduXZTxt" 
      />
      <van-cell 
        v-if="list.isHaveTuanTxt" 
        title="学校是否成立团组织" 
        :value="list.isHaveTuanTxt" 
      />
      <van-cell 
        v-if="list.isHaveTuanJobTxt" 
        title="是否兼任校内团干部职务" 
        :value="list.isHaveTuanJobTxt" 
      />
      <van-cell 
        v-if="list.haveTuanJobMajorTxt" 
        title="兼任校内团干部职务" 
        :value="list.haveTuanJobMajorTxt" 
      />
      <van-cell 
        v-if="list.fdyStartTime" 
        title="任本校大队辅导员开始时间" 
        :value="format(list.fdyStartTime, 6)" 
      />
      <van-cell 
        v-if="list.sxdJobDur" 
        title="累计从事少先队工作年数" 
        :value="list.sxdJobDur" 
      />
      <van-cell 
        v-if="list.isHaveZdFdyJobTxt" 
        title="是否有担任中队辅导员的经历" 
        :value="list.isHaveZdFdyJobTxt" 
      />
      <van-cell 
        v-if="list.zdFdyStartTime" 
        title="担任中队辅导员开始时间" 
        :value="format(list.zdFdyStartTime, 6)" 
      />
      <van-cell 
        v-if="list.zdFdyEndTime" 
        title="担任中队辅导员结束时间" 
        :value="format(list.zdFdyEndTime, 6)" 
      />
      <van-cell 
        v-if="list.schoolMajorTxt" 
        title="校内职务" 
        :value="list.schoolMajorTxt" 
      />
      <van-cell 
        v-if="list.salaryTxt" 
        title="享受待遇" 
        :value="list.salaryTxt" 
      />
      <van-cell 
        v-if="list.titleTxt" 
        title="职称" 
        :value="list.titleTxt" 
      />
      <van-cell 
        v-if="list.teachSubjectNumTxt" 
        title="任教学科门数" 
        :value="list.teachSubjectNumTxt" 
      />
      <van-cell 
        v-if="list.teachSubjectsTxtArray && list.teachSubjectsTxtArray.length > 0" 
        title="任教学科" 
        :value="teachSubjectsTxt" 
      />
      <van-cell 
        v-if="list.otherTeachSubject" 
        title="其他任教学科名称" 
        :value="list.otherTeachSubject" 
      />
      <van-cell 
        v-if="list.classHourNum" 
        title="每周课时数" 
        :value="list.classHourNum" 
      />
      <van-cell 
        v-if="list.zdFdyPxNum" 
        title="2024年度本校中队辅导员参加线下少先队相关培训的人数" 
        :value="list.zdFdyPxNum" 
      />
      <van-cell 
        v-if="list.zdFdyPxXsNum" 
        title="2024年度本校中队辅导员参加互联网线上少先队相关培训的人数" 
        :value="list.zdFdyPxXsNum" 
      />
      <van-cell 
        v-if="list.fDaDuifdyTxt" 
        title="本校除上述已经填报的大队辅导员以外，是否还设有副大队辅导员。（分校区大队辅导员，分设中学部、小学部的大队辅导员等均纳入本次副大队辅导员人数统计）" 
        :value="list.fDaDuifdyTxt" 
      />
    </van-cell-group>
  </div>
</template>

<script setup>
  import { format } from "@/common/js/utils";
  import { defineProps, computed } from 'vue';
  
  // 直接使用 props，不需要定义在 setup 的返回对象中
  const props = defineProps({
    list: Object,
    type: Number,
  });
  const teachSubjectsTxt = computed(() => {
    return props.list.teachSubjectsTxtArray.length > 0 
        ? props.list.teachSubjectsTxtArray.join(", ") 
        : "请选择";
  });
  console.log("form8---EditList", props.list);
</script>

<style lang="less" scoped>
@import "@/common/style/mixin";
.u_sh li {
  display: list-item;
  height: 1.5rem;
}
.u_sh .fl {
  width: 90%;
}
.reason {
  font-size: 0.397rem;
  line-height: 1.4;
  color: #fd3535;
  vertical-align: middle;
  margin: 0.4rem;
}
.custom-cell-title {
  font-weight: bold;
  font-size: 16px;
}
</style>
